<template>
  <div class="apply">

    <div class="apply-top">
      <van-nav-bar title="上传职位">
        <template #left>
          <van-icon name="arrow-left" size="24" @click="goBack"/>
        </template>
        <template #right>
          <van-button plain hairline type="primary" icon="down" size="small"
                      @click="download">下载模板</van-button>
        </template>
      </van-nav-bar>
    </div>

    <div class="apply-body">
      <van-skeleton :row="3" :loading="loading" :style="{ paddingTop: '16px' }">
        <van-form @submit="handleSubmit"  ref="jobUploadForm" scroll-to-error>
          <van-cell-group inset class="submit-form">

            <van-field v-model="companyName" label="公司" placeholder="请选择" readonly is-link
                       @click="isShowCompany = true"
                       name="company"
                       :rules="[{ required: true, message: '公司不能为空' }]" required />
            <van-popup v-model:show="isShowCompany" round position="bottom">
              <van-picker title="选择公司" :columns="companyOption" @cancel="isShowCompany = false" @confirm="setCompany"/>
            </van-popup>

            <van-field v-model="cityName" label="城市" placeholder="请选择" readonly :is-link="cityAble === true"
                       @click="showCityPopup"
                       name="city" type="textarea" autosize
                       :rules="[{ required: true, message: '城市不能为空' }]" required />
            <van-popup v-model:show="isShowCity" round position="bottom">
              <van-picker title="选择城市" :columns="cityOption" @cancel="isShowCity = false" @confirm="setCity"/>
            </van-popup>

            <van-field v-model="benefitName" label="福利待遇" placeholder="请选择" readonly is-link
                       @click="isShowBenefit = true"
                       name="benefit" type="textarea" autosize
                       :rules="[{ required: true, message: '福利待遇不能为空' }]" required />
            <van-popup v-model:show="isShowBenefit" round position="bottom">
              <van-nav-bar title="选择福利待遇"
                           right-text="确认" @click-right="isShowBenefit = false">
                <template #left>
                  <van-checkbox v-model="isCheckAll" :indeterminate="isIndeterminate" @change="checkAllChange">
                    全选
                  </van-checkbox>
                </template>
              </van-nav-bar>
              <van-checkbox-group v-model="checkedResult" @change="checkedResultChange">
                <van-cell-group inset>
                  <van-cell v-for="item in benefitOption" :key="item['value']" :title="item['text']">
                    <template #right-icon>
                      <van-checkbox :name="item['text']"/>
                    </template>
                  </van-cell>
                </van-cell-group>
              </van-checkbox-group>
            </van-popup>

            <van-field v-model="duration" label="招聘期限" placeholder="请选择" readonly is-link
                       @click="isShowDuration = true"
                       name="duration"
                       :rules="[{ required: true, message: '招聘期限不能为空' }]" required />
            <van-calendar v-model:show="isShowDuration" type="range" @confirm="setDuration" />

          </van-cell-group>

          <van-row justify="center" style="margin-top: 20px">
            <van-uploader v-model="excelFile" :max-count="1" accept=".xls,.xlsx"
                          deletable upload-text="选择Excel文件" upload-icon="description-o" :preview-size="[300, 100]" />
          </van-row>

          <div class="button">
            <van-button class="submit-button" type="primary" round block native-type="submit" icon="upgrade">上传</van-button>
          </div>

        </van-form>
      </van-skeleton>
    </div>

  </div>
</template>

<script>


import {downloadJobTemplate, getBenefitOption, getCityOptionForCompany, getCompanyOption, uploadJob} from "@/api";
import {parseTime, selectDictText, selectDictValue} from "@/api/common";
import {showDialog} from "vant";

export default {
  name: "JobUpload",
  data() {
    return {
      loading: true,
      userInfo: {},

      companyName: undefined,
      companyId: 0,
      isShowCompany: false,
      companyOption: [],

      cityAble: false,
      cityName: undefined,
      cityId: undefined,
      isShowCity: false,
      cityOption: [],

      benefitName: '',
      benefitId: '',
      isShowBenefit: false,
      benefitOption: [],
      isCheckAll: false,
      isIndeterminate: false,
      checkedResult: [],

      startAt: undefined,
      endAt: undefined,
      duration: '',
      isShowDuration: false,

      excelFile: [],
    }
  },
  mounted() {
    this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));
    if (this.userInfo['flag'] >= 0) {
      let companyIds = this.userInfo['companyId'].split(',');
      if (this.userInfo['flag'] !== 0) {
        this.companyId = Number(companyIds[0]);

        getCityOptionForCompany('companyId=' + this.companyId).then((res) => {
          if (res.code === 200) {
            this.cityOption = res.data;
            this.cityId = this.cityOption[0]['value'];
            this.cityName = this.cityOption[0]['text'];
            this.cityAble = true;
          }
        });
      } else {
        this.cityAble = false;
      }
      getCompanyOption().then((res) => {
        if (res.code === 200) {
          this.companyOption = res.data;
          this.companyName = selectDictText(this.companyOption, this.companyId);
        }
      });
      getBenefitOption().then((res) => {
        if (res.code === 200) {
          this.benefitOption = res.data;
        }
      });

      this.loading = false;
    } else {
      this.loading = true;
    }
  },
  methods: {
    goBack() {
      window.history.back();
    },
    download() {
      downloadJobTemplate().then(res => {
        if (res.code === 200) {
          window.location.assign(res.msg);
        }
      });
    },
    setCompany(option) {
      let values = option.selectedValues;
      this.companyId = values[0];
      this.companyName = selectDictText(this.companyOption, this.companyId);
      this.isShowCompany = false;

      getCityOptionForCompany('companyId=' + this.companyId).then((res) => {
        if (res.code === 200) {
          this.cityOption = res.data;
          this.cityId = this.cityOption[0]['value'];
          this.cityName = this.cityOption[0]['text'];
          this.cityAble = true;
        }
      });
    },
    showCityPopup() {
      if (this.cityAble === true) {
        this.isShowCity = true;
      }
    },
    setCity(option) {
      let values = option.selectedValues;
      this.cityId = values[0];
      this.cityName = selectDictText(this.cityOption, this.cityId);
      this.isShowCity = false;
    },
    checkAllChange(isAll) {
      this.checkedResult = [];
      this.benefitName = '';
      this.benefitId = '';
      if (isAll === true) {
        for (let item of this.benefitOption) {
          this.checkedResult.push(item['text']);
          this.benefitName += item['text'] + '、';
          this.benefitId += item['value'] + ',';
        }
        this.benefitName = this.benefitName.substring(0, this.benefitName.length - 1);
        this.benefitId = this.benefitId.substring(0, this.benefitId.length - 1);
      }
    },
    checkedResultChange(option) {
      this.checkedResult = option;
      this.isIndeterminate = option.length > 0 && option.length < this.benefitOption.length;

      let optionSorted = {};
      for (let item of option) {
        optionSorted[selectDictValue(this.benefitOption, item)] = item;
      }
      this.benefitName = '';
      this.benefitId = '';
      for (let key in optionSorted) {
        this.benefitName += optionSorted[key] + '、';
        this.benefitId += key + ',';
      }
      this.benefitName = this.benefitName.substring(0, this.benefitName.length - 1);
      this.benefitId = this.benefitId.substring(0, this.benefitId.length - 1);
    },
    setDuration(dates) {
      this.startAt = parseTime(dates[0], '{y}-{m}-{d}') + ' 00:00:00';
      this.endAt = parseTime(dates[1], '{y}-{m}-{d}') + ' 23:59:59';
      this.duration = parseTime(dates[0], '{y}/{m}/{d}') + ' - ' + parseTime(dates[1], '{y}/{m}/{d}')
      this.isShowDuration = false;
    },
    handleSubmit() {
      this.form = new FormData();

      for (let i = 0; i < this.excelFile.length; i++) {
        this.form.append('file', this.excelFile[i].file);
      }
      this.form.append('companyId', this.companyId);
      this.form.append('cityId', this.cityId);
      this.form.append('benefitId', this.benefitId);
      this.form.append('startAt', this.startAt);
      this.form.append('endAt', this.endAt);

      uploadJob(this.form).then((res) => {
        showDialog({
          title: "上传结果",
          message: res.msg,
          messageAlign: "left",
        }).then(() => {
          // on close
        });
      });
    },
  }
}
</script>

<style scoped>
.apply {
  width:100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.apply-top {
  background-color: rgb(248,248,248);
  padding-bottom: 10px;
}

.apply-body {
  flex: 1;
  overflow-y: scroll;
  padding-bottom: 20px;
}

.submit-form {
  margin: 0px 0 0px 0;
}

.button {
  padding: 0 16px 20px;
}

.submit-button {
  font-size: 18px;
  margin-top: 20px;
}
</style>